export default __webpack_public_path__ + "static/media/euklides.43b0f30e.jpg";